import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=69a4134c&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,FooterStoreInfo: require('/~/src/modules/mobiilitukku/components/FooterStoreInfo.vue').default,Footer: require('/~/src/modules/opus-ecom/components/Footer.vue').default})
